import React, { Component } from "react";
import Navbar from "@/modules/Navbar";
import Banner from "./modules/Banner";
import Description from "@/modules/Description";
import CSession from "@/modules/CSession";
import Offices from "@/modules/Offices";
import CardList from "@/modules/CardList";
import ApplyNow from "@/modules/ApplyNow";
import { SubmissionSimple } from "@/modules/Submission";
import Faq from "@/modules/Faq";
import Footer from "@/modules/Footer";
import Application from "@/modules/Application";
import MessageEn from './messageEn'
import Translator from '@/modules/translator';
import Video from '@/modules/Video';
import ImgIntroduce from "./modules/ImgIntroduce";
import themeArrowIcon from '@apgm/assets/svg/them_arrow.svg';
import sessionTriIcon from '@apgm/assets/svg/two_session_triangle.svg';
import emptyTriIcon from '@apgm/assets/svg/left_empty_triangle.svg';



import Times from "./modules/Times";
import Gallery from "./modules/Gallery";
import { $t } from '@/modules/i18n';


import "./App.scss";
function DecorateImgIcon({ leftImg, rightImg }) {
  return (
    <>
      <img src={leftImg} className="left-icon decorate-img-icon" alt={leftImg} />
      <img src={rightImg} className="right-icon decorate-img-icon" alt={rightImg} />
    </>
  )
}

const collectionId = 328;

class App extends Component {
  constructor(props) {
    super(props);
    this.url = "https://careers.shopee.sg/apprenticeprogram";
    this.imageURL = "https://psmss.sp-cdn.shopee.com/api/v4/50027247/msslive-public/57b490e7130f112f25ac24f4fecb72c8";
    this.state = {
      message: MessageEn(),
    }
  }

  getHelmetScript() {
    const message = this.state.message.application;

    return [{
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Event",
        name: $t(message.title),
        description: $t(message.desc),
        image: this.imageURL,
        startDate: $t(message.startDate),
        endDate: $t(message.endDate),
        url: this.url,
        audience: {
          audienceType:
            "Students and Professionals passionate about Data!",
          "@type": "EducationalAudience",
        },
        location: {
          "@type": "Place",
          name: "Shopee Singapore",
          address: "Online",
        }
      })
    }]
  }

  componentDidMount() {
    const { hash } = window.location
    if (hash) {
      const target = document.getElementById(hash.split('#')[1])
      setTimeout(() => {
        window.scrollTo(0, target.getBoundingClientRect().top)
      }, 0);
    }
  }

  render() {
    let Message = this.state.message;
    const script = this.getHelmetScript();
    return (
      <div className="App">
        <Application message={Message.application} url={this.url} imageURL={this.imageURL} script={script} viewport={false} />
        <Navbar message={Message.navbar} />
        <Banner message={Message.banner} />
        <Description message={Message.about} id="about">
          <p className="section-title">{$t('ag_about_title_2')}</p>
        </Description>
        <CSession title={Message.storeForU.title} id="img-introduce">
          <DecorateImgIcon leftImg={sessionTriIcon} rightImg={themeArrowIcon}/>
          <ImgIntroduce message={Message.storeForU}  />
        </CSession>
        <CSession title={Message.teams.title} id="teams">
          <p className="desc-top">{$t(Message.teams.topIntroduce)}</p>
          <Times list={Message.teams.list} />
          <p className="desc-bottom">{$t(Message.teams.bottomIntroduce)}</p>
        </CSession>
        <CSession title={Message.gallery.title} id="testimonials">
          <Gallery message={Message.gallery} />
        </CSession>
        <CSession id="card-list" title={Message.haveITaskCards.title}>
          <DecorateImgIcon leftImg={emptyTriIcon} rightImg={emptyTriIcon}/>
          <CardList list={Message.haveITaskCards.list} />
        </CSession>
        <CSession id="submission" title={Message.submission.title}>
          <SubmissionSimple message={Message.submission} />
        </CSession>
        <Video message={Message.video}></Video>
        <CSession id="offices" title={Message.offices.title}>
          <Offices message={Message.offices} />
        </CSession>
        <Faq message={Message.faq}>
          <ApplyNow/>
        </Faq>
        <Footer message={Message.footer} />
      </div>
    );
  }
}

export default Translator(App, MessageEn, {}, { collectionId });
